import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import IdentificationSummary from '@/checkout-instore-legacy/components/Commons/Summary/components/IdentificationSummary'

import { actionCreators } from '@/checkout-instore-legacy/customer/actions'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(undefined, mapDispatchToProps)(IdentificationSummary)
